import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import Tabs from 'components/layout/Tabs';

import ClientLocationData from 'components/layout/client/ClientLocationData';
import ClientLocationSalesPointData from 'components/layout/client/ClientLocationSalesPointData';
import ClientLocationServicePointData from 'components/layout/client/ClientLocationServicePointData';
import ClientLocationRentalPointData from 'components/layout/client/ClientLocationRentalPointData';
import ClientLocationWarehouseData from 'components/layout/client/ClientLocationWarehouseData';

class ClientLocationDetails extends React.Component {
  getTabHeaderList = () => {
    const {
      intl: { messages },
      data,
    } = this.props;
    const result = [];

    result.push(messages.formGroup.basic_information);
    result.push([data.getIsSalesPoint() ? <i class="fal fa-check m-r-10" /> : null, messages.sales_point]);
    result.push([data.getIsServicePoint() ? <i class="fal fa-check m-r-10" /> : null, messages.service_point]);
    result.push([data.getIsRentalPoint() ? <i class="fal fa-check m-r-10" /> : null, messages.rental_point]);
    result.push([data.getIsWarehouse() ? <i class="fal fa-check m-r-10" /> : null, messages.warehouse]);

    return result;
  };

  getTabContentList = () => {
    const {
      entity,
      entityLoaded,
      changeEntity,
      data,
      user,
      shownIndex,
      timezone,
      disabled,
      projectConfig,
    } = this.props;
    const result = [];

    result.push(
      <ClientLocationData
        entityLoaded={entityLoaded}
        entity={entity}
        changeEntity={changeEntity}
        data={data}
        user={user}
        shownIndex={shownIndex}
        timezone={timezone}
        disabled={disabled}
        projectConfig={projectConfig}
      />
    );
    result.push(
      <ClientLocationSalesPointData
        entityLoaded={entityLoaded}
        entity={entity}
        changeEntity={changeEntity}
        data={data}
        user={user}
        shownIndex={shownIndex}
        timezone={timezone}
        disabled={disabled}
      />
    );
    result.push(
      <ClientLocationServicePointData
        entityLoaded={entityLoaded}
        entity={entity}
        changeEntity={changeEntity}
        data={data}
        user={user}
        shownIndex={shownIndex}
        timezone={timezone}
        disabled={disabled}
      />
    );
    result.push(
      <ClientLocationRentalPointData
        entityLoaded={entityLoaded}
        entity={entity}
        changeEntity={changeEntity}
        data={data}
        user={user}
        shownIndex={shownIndex}
        timezone={timezone}
        disabled={disabled}
      />
    );
    result.push(
      <ClientLocationWarehouseData
        entityLoaded={entityLoaded}
        entity={entity}
        changeEntity={changeEntity}
        data={data}
        user={user}
        shownIndex={shownIndex}
        timezone={timezone}
        disabled={disabled}
      />
    );

    return result;
  };

  getTabKeepMounted = () => {
    const keepMounted = [];
    return keepMounted;
  };

  render() {
    const { colSpan } = this.props;

    return (
      <tr class="row-details">
        <td colSpan={colSpan}>
          <Tabs
            tabs={this.getTabHeaderList()}
            tabContent={this.getTabContentList()}
            keepMounted={this.getTabKeepMounted()}
          />
        </td>
      </tr>
    );
  }
}
ClientLocationDetails.defaultProps = {};

const mapStateToProps = state => {
  return {
    projectConfig: state.data.projectConfig,
  };
};

export default injectIntl(connect(mapStateToProps)(ClientLocationDetails));
